'use client';

import { animatedPath } from './animated.logo.css';

export const AnimatedLogo = ({ width = 80, height = 100 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 237 297"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_622_136"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-60"
        y="0"
        width="357"
        height="357"
      >
        <path
          d="M296.25 178.2C296.25 276.617 216.669 356.4 118.5 356.4C20.3314 356.4 -59.25 276.617 -59.25 178.2C-59.25 79.7829 20.3314 0 118.5 0C216.669 0 296.25 79.7829 296.25 178.2ZM59.2501 178.2C59.2501 211.006 85.7772 237.6 118.5 237.6C151.223 237.6 177.75 211.006 177.75 178.2C177.75 145.394 151.223 118.8 118.5 118.8C85.7772 118.8 59.2501 145.394 59.2501 178.2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_622_136)">
        <ellipse className={animatedPath} cx="118.5" cy="178.2" rx="118.5" ry="118.8" />
        <ellipse className={animatedPath} cx="118.5" cy="77.22" rx="77.025" ry="77.22" />
        <ellipse cx="118.5" cy="178.2" rx="59.25" ry="59.4" fill="white" />
        <path
          className={animatedPath}
          d="M213.3 106.92C199.08 85.536 194.932 59.4 189.6 47.52V106.92H213.3Z"
        />
        <path
          className={animatedPath}
          d="M23.7 106.92C37.92 85.536 42.0675 59.4 47.4 47.52V106.92H23.7Z"
        />
      </g>
    </svg>
  );
};
